
import {
  FETCH_LEAVE_TYPES_REQUEST,
  FETCH_LEAVE_TYPES_SUCCESS,
  FETCH_LEAVE_TYPES_FAILURE,
  CREATE_LEAVE_TYPE_REQUEST,
  CREATE_LEAVE_TYPE_SUCCESS,
  CREATE_LEAVE_TYPE_FAILURE,
  UPDATE_LEAVE_TYPE_REQUEST,
  UPDATE_LEAVE_TYPE_SUCCESS,
  UPDATE_LEAVE_TYPE_FAILURE,
  DELETE_LEAVE_TYPE_REQUEST,
  DELETE_LEAVE_TYPE_SUCCESS,
  DELETE_LEAVE_TYPE_FAILURE,
} from "../actions/leaveTypeActions";

const initialState = {
  leaveTypes: [],
  loading: false,
  error: null,
  creating: false,
  createError: null,
  updating: false,
  updateError: null,
  deleting: false,
  deleteError: null,
};

const leaveTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH
    case FETCH_LEAVE_TYPES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_LEAVE_TYPES_SUCCESS:
      return { ...state, loading: false, leaveTypes: action.payload };
    case FETCH_LEAVE_TYPES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // CREATE
    case CREATE_LEAVE_TYPE_REQUEST:
      return { ...state, creating: true, createError: null };
    case CREATE_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        creating: false,
        leaveTypes: [...state.leaveTypes, action.payload.data],
      };
    case CREATE_LEAVE_TYPE_FAILURE:
      return { ...state, creating: false, createError: action.payload };

    // UPDATE
    case UPDATE_LEAVE_TYPE_REQUEST:
      return { ...state, updating: true, updateError: null };
    case UPDATE_LEAVE_TYPE_SUCCESS:
  return {
    ...state,
    updating: false,
    leaveTypes: state.leaveTypes.map((lt) =>
      lt.id === action.payload.data.id
        ? { ...lt, ...action.payload.updated } // merge updated fields
        : lt
    ),
  };
    case UPDATE_LEAVE_TYPE_FAILURE:
      return { ...state, updating: false, updateError: action.payload };

    // DELETE
    case DELETE_LEAVE_TYPE_REQUEST:
      return { ...state, deleting: true, deleteError: null };
    case DELETE_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        deleting: false,
        leaveTypes: state.leaveTypes.filter((lt) => lt.id !== action.payload),
      };
    case DELETE_LEAVE_TYPE_FAILURE:
      return { ...state, deleting: false, deleteError: action.payload };

    default:
      return state;
  }
};

export default leaveTypeReducer;
